<template>
  <a-loading :loading="openGameRoundMeta.loading || casinoMeta.loading">
    <l-rows>
      <m-header
        :title-text="casino.name"
        :subtitle-text="`${$t('support.player')} ${openGameRound.playerId}`"
      />
      <a-box>
        <l-rows>
          <l-columns
            space="between"
          >
            <l-rows gap="0">
              <m-header
                :title-text="openGameRound.gameName"
                :subtitle-text="formatDateTime(openGameRound.creationDate)"
                :size="4"
              />
              <p><i class="fas fa-circle-notch" /> {{ openGameRound.id }}</p>
            </l-rows>
            <div
              class="cu-badge"
              :class="classes"
            >
              {{ refundable ? $t('support.refundable') : $t('support.notRefundable') }}
            </div>
          </l-columns>
          <p>
            <span class="bo-open-game-round__debit">{{ openGameRound.debit }}</span> {{ $t('support.debit') }} &bull;
            <span class="bo-open-game-round__credit">{{ openGameRound.credit }}</span> {{ $t('support.credit') }} &bull;
            <span class="bo-open-game-round__total-win">{{ openGameRound.totalWin }}</span> {{ $t('support.totalWin') }}
          </p>
        </l-rows>
      </a-box>
      <a-box>
        <o-form
          async
          :title="$t('support.refundOpenGameRound')"
          :subtitle="$t('support.refundOpenGameRoundDescription')"
          :submit-text="$t('support.refund')"
          :inputs="refundInputs"
          submit-variant="warning"
          :submit-disabled="refundDisabled"
          submit-disabled-reason=""
          @submit="refundOpenGameRound"
        />
      </a-box>
    </l-rows>
  </a-loading>
</template>

<script>
  import { useOpenGameRound, useRefundOpenGameRound } from '@/views/support/hooks'
  import { ABox, ALoading, LColumns, LRows, MHeader, OForm } from 'codefabrik-gui-vue'
  import { useCasino } from '@/views/casinos/casinoHooks'
  import { formatDateTime } from '@/shared'

  export default {
    name: 'OpenGameRound',
    components: { LRows, ABox, MHeader, LColumns, ALoading, OForm },
    data () {
      return {
        openGameRoundIdEntered: false,
      }
    },
    computed: {
      refundable () {
        return this.openGameRound.credit === 0
      },
      classes () {
        return [
          this.refundable ? 'cu-badge--active' : 'cu-badge--inactive',
        ]
      },
      refundDisabled () {
        return !this.openGameRoundIdEntered || !this.refundable
      },
      refundInputs () {
        return [
          {
            name: 'gameRoundId',
            onUpdate: this.handleGameRoundIdInput,
            properties: {
              help: this.$t('support.enterGameRoundId')
            },
            disabled: !this.refundable
          }
        ]
      }
    },
    methods: {
      formatDateTime: formatDateTime,
      handleGameRoundIdInput (value) {
        this.openGameRoundIdEntered = value === this.openGameRound.id
      }
    },
    mixins: [
      useOpenGameRound(),
      useRefundOpenGameRound(),
      useCasino('casino', 'casinoId')
    ]
  }
</script>

<style scoped>
  .bo-open-game-round__debit {
    font-weight: bold;
    color: #2c7944;
  }

  .bo-open-game-round__credit {
    font-weight: bold;
    color: #9B2C2C;
  }

  .bo-open-game-round__total-win {
    font-weight: bold;
    color: #796f2c;
  }
</style>
